import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// NAVIGATION
import { useNavigate } from "react-router-dom";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { RootState } from "../../../app/store";

export default function ControlPanelBankConfiguration({ bankId }: { bankId: string }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const navigate = useNavigate();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickCell = () => {
		if (bankId) {
			navigate({
				pathname: "/edge-management/banks/configuration",
				search: `?idBank=${bankId}`,
			});
		}
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div
			className={`monitoringView__controlPanel__${theme}`}
			style={{ minHeight: "400px", height: "auto", padding: "20px" }}
		>
			<div className={`drawer__box__control__panel__${theme} generalStyles__flexCenter`}>
				<Button
					type='primary'
					icon={<FontAwesomeIcon icon={faGear} className='generalStyles__mrFix' />}
					onClick={onClickCell}
				>
					Configuration
				</Button>
			</div>
		</div>
	);
}
